import { CHANGE_ACCESSORY_CHOICES, CHANGE_FILTER_CHOICES } from '../actions/index';


// default states
// Store user choices so they can be restored when returning from viewing the order list
// These will be cleared when choosing a new monitor
const choicesState = {
  accessoryChoices: null,
  filterChoices: null
};

// reducers
function choices(state = choicesState, action) {
  switch (action.type) {
    case CHANGE_ACCESSORY_CHOICES:
      return {
        ...state,
        accessoryChoices: action.newAccessoryChoices
      };
    case CHANGE_FILTER_CHOICES:
      return {
        ...state,
        filterChoices: action.newFilterChoices
      };
    default:
      return state;
  }
}

export default choices;
